import { CACHE_PREFIX } from './cache-prefix'

export const REQUEST_ACCESS_URL = 'https://thehub.thomsonreuters.com/groups/reuters-graphics-portal'

export const AUTH = {
  REDIRECT_TIMEOUT: 60000,
  LAST_REDIRECTION: `${CACHE_PREFIX}last_auth_redirect`,
}
